import { Achievement } from '../../lib/achievements'
import { useState } from 'react'
import { AchievementModal } from './AchievementModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
  achievements: Achievement[]
}

export const BatchedAchievementModal = ({achievements, isOpen, handleClose}: Props) => {
  const [index, setIndex] = useState(0)
  // on isOpen show first Achievement, increment current achievement until all are closed
  const onClose = () => {
    setIndex(index + 1)
    console.log(index)
    if(index === achievements.length - 1) {
      console.log('handle batched achievement close')
      setIndex(0)
      handleClose()
    }
  }

  return ( 
  <>{achievements.map((a, i) => {
    return <AchievementModal key={a.getTitle()} achievement={a} isOpen={isOpen && index === i} handleClose={onClose} />
    })}
  </>
  )
}
